import Box from '@mui/material/Box'
import { styled } from '@mui/system'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'

const UserInitialPswdBox = styled(Box)`
	display: flex;
	align-items: center;
	padding-right: 2rem;
	position: relative;
`

const UserInitialPswdLabel = styled(Typography)`
	font-family: Gilroy-Semibold, sans-serif;
	font-size: 1.1875rem;
	text-align: right;
`

const UserInitialPswdCopyBtn = styled(IconButton)(({ theme }) => ({
	fontSize: '0.875rem',
	position: 'absolute',
	right: 0,
	border: `0.0625rem solid ${theme.palette.grey[300]}`,
}))

export { UserInitialPswdLabel, UserInitialPswdBox, UserInitialPswdCopyBtn }
